import { useTranslation } from 'react-i18next';

import { Link, useLocation } from '@remix-run/react';
import cx from 'classnames';

type RefreshPageProps = {
  isFullWidth: boolean;
};

const RefreshPage = ({ isFullWidth = false }: RefreshPageProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const title = t('errors.refresh.title');
  const description = t('errors.refresh.description');
  const label = t('errors.refresh.label');

  return (
    <div
      className={cx(
        'mx-auto flex min-h-screen items-center justify-center bg-white px-4 py-24',
        isFullWidth ? 'w-full' : 'max-w-3xl',
      )}
    >
      <div className={cx('mx-auto', isFullWidth ? 'max-w-screen-lg' : 'max-w-max')}>
        <main className="sm:flex">
          <div className="sm:ml-6">
            <div className="sm:pl-6">
              <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">{title}</h1>

              <p className="my-4 text-base text-gray-500">{description}</p>

              <Link
                to={location.pathname + location.search}
                reloadDocument
                className="mt-1 text-base text-gray-600 underline"
              >
                {label}
              </Link>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default RefreshPage;
